import type { SynastryV2Response } from '@/api/schema/synastry'
import { Emoji } from '@/app/components/Emoji/Emoji'
import { Col, Row } from '@/app/components/Flex/Flex'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import type { FunctionalComponent } from 'preact'

export const SynastryMain: FunctionalComponent<{
  data: SynastryV2Response
}> = props => {
  return (
    <UI.Panel
      shadow
      type='user'
    >
      <Row gap={5}>
        <Col gap={10} justifyContent='center'>
          <Col alignItems='center' gap={2}>
            <Emoji type='love' />
            <Text fontWeight={600} fontSize={14} fontSizeMobile={13}>
              {props.data.love}/10
            </Text>
          </Col>

          <Col alignItems='center' gap={2}>
            <Emoji type='sex' />
            <Text fontWeight={600} fontSize={14} fontSizeMobile={13}>
              {props.data.sex}/10
            </Text>
          </Col>

          <Col alignItems='center' gap={2}>
            <Emoji type='message' />
            <Text fontWeight={600} fontSize={14} fontSizeMobile={13}>
              {props.data.communication}/10
            </Text>
          </Col>
        </Col>

        <Text
          fontSize={20}
          fontWeight={600}
          textAlign='center'
        >
          {props.data.title}
        </Text>

        <UI.Holder maxWidth={420}>
          <Text fontSize={16} textAlign='center'>
            {props.data.desc}
          </Text>
        </UI.Holder>
      </Row>
    </UI.Panel>
  )
}
